import { Success, WarningFilled } from 'components/atoms/icons'
import { INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { IFileBody } from './file'
import { ICarrierApplicationStates } from './graphqlTypes'

export interface IFileCreate extends IFileBody {
  _destroy?: boolean
  blobId?: number
  uuid?: string
}

interface IBrokerCarrierAgreement {
  createdDate: string
  signedAgreementUrl: string
}
export interface IReference {
  companyName: string
  phone: string
}

export interface IUpdateCarrierReferences {
  carrierReferences: IReference[]
}
export interface ISubmitCarrierPackageFiles {
  packageFiles: IFileCreate[]
}
export interface ISubmitBrokerCarrierAgreementPayload {
  carrierApplication: ICarrierApplicationPayload
  brokerCarrierAgreement: IBrokerCarrierAgreementPayload
}
export interface IBrokerCarrierAgreementPayload {
  signatory: string
}

export interface ICarrierApplicationPayload {
  ein: string
  entityType: string
  contactEmail: string
  locationAttributes: ILocation
}

interface ILocation {
  id?: number
  address: string
  city: string
  stateCode: string
  zipcode: string
  countryCode: string
  contactEmail: string
  contactPhone: string
}

export interface ICarrierPackageFile {
  carrierApplication: number
  createdAt: string
  createdById: string
  fileContentType: string
  fileFileName: string
  fileFileSize: string
  filePrivateContentType: string | null
  filePrivateFileName: string | null
  filePrivateFileSize: string | null
  filePrivateUpdatedAt: string | null
  fileUpdatedAt: string
  fileUrl: string | null
  id: number
  updatedAt: string
}

export interface ICarrierApplication {
  id: string
  factor: boolean
  insuranceAutoLiabilityCoverage: string
  mcNumber: string
  dotNumber: string
  name: string
  fleetPlannerMotorCarrierId: string
  legalName?: string
  location?: ILocation
  brokerCarrierAgreement?: IBrokerCarrierAgreement | null
  carrierReferences?: IReference[]
  packageFiles?: ICarrierPackageFile[]
  automotiveInsurance?: {
    policyType?: 'Scheduled Auto' | 'Any Auto'
  }
  carrierSpecificInfo?: string
  keepTruckinEnabled: boolean
  /**
   * `isEldApproved` is set to value of `is_p44_active?` in the BE serializer
   */
  isEldApproved: boolean
}

export interface ICarrierComplianceRequirementMatch {
  shipperRequirement: string
  carrierAttr: string
  valid: boolean
}

export enum CarrierFMCSAStatus {
  satisfactory = 'SATISFACTORY',
  notRated = 'NOT RATED',
  unsatisfactory = 'UNSATISFACTORY',
  outOfService = 'OUT OF SERVICE',
}

export const CARRIER_FMCSA_STATUSES = {
  SATISFACTORY: {
    Icon: Success,
    variant: INLINE_MESSAGE_VARIANTS.INFO,
    text: 'FMCSA rating is Satisfactory',
  },
  'NOT RATED': {
    Icon: Success,
    variant: INLINE_MESSAGE_VARIANTS.INFO,
    text: 'FMCSA rating is Satisfactory',
  },
  UNSATISFACTORY: {
    Icon: WarningFilled,
    variant: INLINE_MESSAGE_VARIANTS.WARNING,
    text: 'FMCSA rating is Unsatisfactory',
  },
  'OUT OF SERVICE': {
    Icon: WarningFilled,
    variant: INLINE_MESSAGE_VARIANTS.WARNING,
    text: 'FMCSA rating is Unsatisfactory',
  },
}

export interface ICarrierCompliance {
  requirementsMatchResults: ICarrierComplianceRequirementMatch[]
  meetsRequirements: boolean
  state: ICarrierApplicationStates
  fmcsaRating: CarrierFMCSAStatus
}
